export default {
  name: 'marking--remarkPrimaryDocType',
};